/**
 * Resolve an API path against the configured backend base URL.
 * In development this points to the local Wrangler dev server (default 8787).
 * In production it should be set to the deployed Worker domain.
 */
export function apiUrl(path: string): string {
  const base = import.meta.env.VITE_API_URL || 'http://localhost:8787'
  const normalized = path.startsWith('/') ? path : `/${path}`
  return `${base.replace(/\/$/, '')}${normalized}`
}
